export enum Role {
  Broker = 'broker',
  UserManager = 'user-manager',
  BrokerUserManager = 'broker-user-manager',
  ClaimsAssessor = 'claims-assessor',
  ClaimsManager = 'claims-manager',
  ClaimsTeamLeader = 'claims-team-leader',
  Default = 'default-roles-greydom',
  EnterpriseManager = 'enterprise-manager',
  EnterpriseTeamLeader = 'enterprise-team-leader',
  FinancialManager = 'financial-manager',
  FinancialTeamLeader = 'financial-team-leader',
  GreydomAdmin = 'greydom-admin',
  OperationsManager = 'operations-manager',
  PharmacyManager = 'pharmacy-manager',
  PreAuthorisationManager = 'pre-authorisation-manager',
  PreAuthorisationTeamLeader = 'pre-authorisation-team-leader',
  Provider = 'provider',
  ProviderUserManager = 'provider-user-manager',
  ClaimReverser = 'claim-reverser',
  OnBoardingManager = 'onboarding-manager',
  OnBoardingTeamLeader = 'onboarding-team-leader',
  OnBoardingQC = 'onboarding-qc'
}
